function getBannerEl() {
  return document.getElementById('cookies-banner');
}

function hideBanner(res) {
  getBannerEl().style.display = 'none';
  document.getElementById('cookies-banner-overlay').style.display = 'none';
}

function showBanner() {
  getBannerEl().style.display = 'inline-block';
  document.getElementById('cookies-banner-overlay').style.display = 'block';
}

function handleAccept(e) {
  window.Shopify.customerPrivacy.setTrackingConsent({"analytics":true,"marketing":true,"preferences":true,"sale_of_data":true},hideBanner);
  setTimeout(() => { window.location.reload(); }, 500);
}

function handleDecline() {
  window.Shopify.customerPrivacy.setTrackingConsent({"analytics":false,"marketing":false,"preferences":true,"sale_of_data": false},hideBanner);
  setTimeout(() => { window.location.reload(); }, 500);
}

function handlePolicyClick(policy_url) {
  handleDecline();
  setTimeout(() => { window.location = policy_url; }, 500);
}

function initCookieBanner() {
  const privacy_settings = window.Shopify.customerPrivacy.currentVisitorConsent();
  if(privacy_settings.marketing =='' || privacy_settings.analytics =='' || privacy_settings.preferences =='' || privacy_settings.sale_of_data =='') {
    showBanner();
  }
}

window.Shopify.loadFeatures([
  {
    name: 'consent-tracking-api',
    version: '0.1',
  }
],
function(error) {
  if (error) {
    throw error;
  }
  
  initCookieBanner();
});
